import React from "react";

const BrokenStar = () => {
  return (
      <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
        <g clipPath="url(#clip0_82_67)">
          <path
            d="M5.43046 4.6815C5.68396 4.227 5.81046 4 5.99996 4C6.18946 4 6.31596 4.227 6.56946 4.6815L6.63446 4.799C6.70696 4.9285 6.74296 4.993 6.79896 5.0355C6.85496 5.078 6.92496 5.094 7.06496 5.1255L7.19196 5.1545C7.68396 5.2655 7.92996 5.3215 7.98846 5.5095C8.04696 5.698 7.87946 5.894 7.54396 6.286L7.45696 6.3875C7.36196 6.499 7.31446 6.5545 7.29296 6.6235C7.27146 6.6925 7.27846 6.767 7.29296 6.9155L7.30596 7.0505C7.35696 7.574 7.38196 7.8355 7.22896 7.952C7.07596 8.0685 6.84546 7.962 6.38496 7.7505L6.26546 7.6955C6.13496 7.6355 6.06946 7.605 5.99996 7.605C5.93046 7.605 5.86496 7.635 5.73446 7.695L5.61496 7.75C5.15496 7.9625 4.92396 8.0685 4.77096 7.952C4.61796 7.836 4.64296 7.574 4.69396 7.051L4.70696 6.9155C4.72146 6.767 4.72846 6.6925 4.70696 6.6235C4.68546 6.5545 4.63796 6.4985 4.54296 6.3875L4.45596 6.286C4.12096 5.894 3.95296 5.698 4.01146 5.5095C4.06996 5.3215 4.31596 5.2655 4.80796 5.1545L4.93496 5.1255C5.07496 5.094 5.14496 5.078 5.20096 5.0355C5.25696 4.993 5.29296 4.9285 5.36496 4.799L5.43046 4.6815Z"
            stroke="#EC1066"
            strokeWidth="0.9375"
          />
          <path
            d="M3.5 1.66901C4.25976 1.22946 5.12225 0.998653 6 1.00001C8.7615 1.00001 11 3.23851 11 6.00001C11 8.76151 8.7615 11 6 11C3.2385 11 1 8.76151 1 6.00001C1 5.08951 1.2435 4.23501 1.669 3.50001"
            stroke="#EC1066"
            strokeWidth="0.9375"
            strokeLinecap="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_82_67">
            <rect width="12" height="12" fill="white" />
          </clipPath>
        </defs>
      </svg>
  );
};

export default BrokenStar;
